import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'routing',
  templateUrl: './routing.component.html',
  styleUrls: ['./routing.component.scss']
})
export class RoutingComponent implements OnInit {

  routingServicesItems;

  constructor() {
    this.routingServicesItems = [
      {routerLink: 'qualityBasedRouting', name: 'quality based routing'},
      {routerLink: 'timeBasedRouting', name: 'time based routing'},
      {routerLink: 'altRoutingSIPReasons', name: 'alternative routing SIP reasons'},
      {routerLink: 'routingSettings', name: 'routing settings'},
      {routerLink: 'registrationRoutingSettings', name: 'registration settings'},
      {routerLink: 'callsQuotaSettings', name: 'calls quota'},
      {routerLink: 'cacProfiles', name: 'CAC Profiles'},
      {routerLink: 'shortCallsProfilesSettings', name: 'Short Calls Profiles'}
    ];
  }

  ngOnInit(): void {
  }

}
